import React from "react";

const Iopheader = () => {
  return (
    <div className="container">
      <div className="faq-content py-0">
        <div className="faq-content-block py-4 mt-2">
          {/* <h1 className="faqs mb-0 text-center">
            Intensive Outpatient Program Options
          </h1> */}
        </div>
      </div>
    </div>
  );
};

export default Iopheader;
